import { Component, ErrorInfo, lazy, ReactNode } from 'react';
import { Title } from 'src/components/feedback/error-boundary';
import { SimplePageLayout } from 'src/components/layout/simple-page-layout';
import { MissingMock } from 'src/utils/errors';
import { reportError } from 'src/utils/report-error';

const UnknownError = lazy(() => import('../../pages/errors/unknown'));

type State = { error: unknown };

export class FatalErrorBoundary extends Component<
  { children?: ReactNode },
  State
> {
  state: State = { error: undefined };

  static getDerivedStateFromError(error: unknown) {
    if (error instanceof MissingMock) throw error;
    return { error };
  }

  componentDidCatch(error: unknown, errorInfo: ErrorInfo) {
    reportError(error, errorInfo);
  }

  render() {
    const { error } = this.state;
    if (error === undefined) return this.props.children;

    return (
      <SimplePageLayout>
        <Title>Fatal Error</Title>
        <UnknownError />
      </SimplePageLayout>
    );
  }
}
